import * as React from 'react';
import { Icon } from 'office-ui-fabric-react';
import { SemanticIconName } from './SemanticIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export let ContentTypeIconName = /*#__PURE__*/function (ContentTypeIconName) {
  ContentTypeIconName["Movie"] = "MyMoviesTV";
  ContentTypeIconName["TVShow"] = "TVMonitor";
  ContentTypeIconName["TVSeries"] = "Stack";
  ContentTypeIconName["TVSeason"] = "Stack";
  ContentTypeIconName["TVSingle"] = "TVMonitorSelected";
  ContentTypeIconName["TVEpisode"] = "PresenceChickletVideo";
  ContentTypeIconName["TVEpisodes"] = "PresenceChickletVideo";
  ContentTypeIconName["ShortFilm"] = "PanoIndicator";
  ContentTypeIconName["FeatureDoc"] = "Cat";
  ContentTypeIconName["Advert"] = "Savings";
  ContentTypeIconName["Promotion"] = "Starburst";
  ContentTypeIconName["Ancillary"] = "OEM";
  ContentTypeIconName["Safety"] = "ConstructionCone";
  ContentTypeIconName["ClientSpecific"] = "Airplane";
  return ContentTypeIconName;
}({});
const getIcon = contentType => {
  switch (contentType) {
    case 'Movie':
      return ContentTypeIconName.Movie;
    case 'TvShow':
      return ContentTypeIconName.TVShow;
    case 'TvSeries':
      return ContentTypeIconName.TVSeries;
    case 'TvSeason':
      return ContentTypeIconName.TVSeason;
    case 'TvEpisode':
      return ContentTypeIconName.TVEpisode;
    case 'TvSingle':
      return ContentTypeIconName.TVSingle;
    case 'TV':
      return ContentTypeIconName.TVEpisode;
    case 'FeatureDoc':
      return ContentTypeIconName.FeatureDoc;
    case 'ShortFilm':
      return ContentTypeIconName.ShortFilm;
    case 'Ancillary':
      return ContentTypeIconName.Ancillary;
    case 'Safety':
      return ContentTypeIconName.Safety;
    case 'ClientSpecific':
      return ContentTypeIconName.ClientSpecific;
    default:
      return SemanticIconName.Unknown;
  }
};
export const ContentTypeIcon = /*#__PURE__*/React.memo(_ref => {
  let {
    name,
    contentType
  } = _ref;
  if (name) {
    return /*#__PURE__*/_jsx(Icon, {
      iconName: name
    });
  }
  const iconName = getIcon(contentType);
  return /*#__PURE__*/_jsx(Icon, {
    iconName: iconName
  });
});